/**
 * Mapas de rótulo PT + semáforo para a tela Templates Meta WhatsApp.
 *
 * O wire vem em lowercase (`utility`/`approved`); o gabarito Claude Design usa
 * rótulos uppercase/PT. Centralizamos a tradução aqui (UI honesta: `submitted`
 * → "Pendente", como no gabarito).
 */

import type { TemplateCategory, TemplateStatus } from './types';

export type Semaforo = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

interface StatusMeta {
  label: string;
  semaforo: Semaforo;
  /** Glifo curto do gabarito (✓ ⏳ ✗ ·). */
  glyph: string;
}

const STATUS_META: Record<TemplateStatus, StatusMeta> = {
  approved: { label: 'Aprovado', semaforo: 'success', glyph: '✓' },
  submitted: { label: 'Pendente', semaforo: 'warning', glyph: '⏳' },
  rejected: { label: 'Rejeitado', semaforo: 'danger', glyph: '✗' },
  draft: { label: 'Rascunho', semaforo: 'neutral', glyph: '·' },
  paused: { label: 'Pausado', semaforo: 'info', glyph: '⏸' },
  disabled: { label: 'Desativado', semaforo: 'neutral', glyph: '·' },
};

export function statusMeta(status: TemplateStatus): StatusMeta {
  return STATUS_META[status] ?? { label: status, semaforo: 'neutral', glyph: '·' };
}

// Labels PT (a Meta traduz as categorias assim no próprio painel PT-BR);
// o valor de wire segue o enum EN da API.
const CATEGORY_LABEL: Record<TemplateCategory, string> = {
  utility: 'UTILIDADE',
  marketing: 'MARKETING',
  authentication: 'AUTENTICAÇÃO',
};

export function categoryLabel(category: TemplateCategory): string {
  return CATEGORY_LABEL[category] ?? category.toUpperCase();
}

/** Semáforo da pílula de categoria (espelha o gabarito). */
export function categorySemaforo(category: TemplateCategory): Semaforo {
  if (category === 'marketing') return 'warning';
  if (category === 'authentication') return 'info';
  return 'success';
}

export const CATEGORY_DESCRIPTIONS: Record<TemplateCategory, string> = {
  authentication: 'OTPs e códigos',
  utility: 'notificações transacionais',
  marketing: 'campanhas (políticas restritivas)',
};
